export default __webpack_public_path__ + "static/media/theano.11df6eca.svg";